import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { ArrowLeft, Shield } from 'lucide-react';

const PrivacyPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4" data-testid="privacy-page">
      <div className="max-w-4xl mx-auto">
        {/* Back Button */}
        <Link 
          to="/" 
          className="inline-flex items-center text-slate-600 hover:text-slate-900 mb-8"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Torna alla Home
        </Link>

        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-8 mb-8">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-12 bg-slate-900 rounded-sm flex items-center justify-center">
              <Shield className="h-6 w-6 text-orange-500" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-slate-900" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
                Privacy Policy (GDPR)
              </h1>
              <p className="text-slate-500">Informativa sul trattamento dei dati personali</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-8 prose prose-slate max-w-none">
          
          {/* Titolare */}
          <div className="bg-slate-50 p-4 rounded-lg mb-8">
            <h3 className="text-lg font-semibold text-slate-900 mt-0 mb-2">Titolare del Trattamento</h3>
            <p className="mb-1"><strong>Delta Impianti Polska</strong></p>
            <p className="mb-1">ul. św. Antoniego Padewskiego 5/7, 90-038 Lodz</p>
            <p className="mb-0">
              Email: <a href="mailto:deltaimpianti.de@gmail.com" className="text-orange-500 hover:underline">
                deltaimpianti.de@gmail.com
              </a>
            </p>
          </div>

          <h2 className="text-xl font-semibold text-slate-900">1. Dati Raccolti e Finalità</h2>
          <p>Trattiamo i seguenti dati personali:</p>
          <ul>
            <li><strong>Dati identificativi:</strong> Nome, Cognome</li>
            <li><strong>Dati di contatto:</strong> Email, Telefono</li>
            <li><strong>Dati professionali:</strong> Competenze, Certificazioni</li>
            <li><strong>Dati di geolocalizzazione:</strong> Città/Provincia</li>
          </ul>
          <p>
            La finalità è l'erogazione del servizio di "matching" professionale nel settore dell'automazione industriale.
          </p>

          <h2 className="text-xl font-semibold text-slate-900">2. Base Giuridica</h2>
          <p>
            Il trattamento si fonda sull'<strong>esecuzione di un contratto</strong> di cui l'interessato è parte 
            (Art. 6.1.b GDPR) e sul <strong>consenso esplicito</strong> per la pubblicazione del profilo professionale.
          </p>

          <h2 className="text-xl font-semibold text-slate-900">3. Visibilità e Diffusione dei Dati</h2>
          <p>
            I dati dei Professionisti <strong>non sono pubblici</strong>, ma sono accessibili esclusivamente alle Aziende 
            regolarmente registrate e paganti. I dati <strong>non saranno venduti a terzi</strong> per scopi di marketing.
          </p>

          <h2 className="text-xl font-semibold text-slate-900">4. Geolocalizzazione</h2>
          <p>
            L'App utilizza la posizione geografica dichiarata dal Professionista per permettere alle Aziende di filtrare 
            i risultati in base alla vicinanza agli impianti. L'indirizzo esatto <strong>non viene mostrato</strong> nelle 
            ricerche generali per tutelare la riservatezza del Professionista.
          </p>

          <h2 className="text-xl font-semibold text-slate-900">5. Diritti dell'Interessato</h2>
          <p>Ai sensi del GDPR, l'utente può in ogni momento:</p>
          <ul>
            <li><strong>Accedere</strong> ai propri dati o chiederne la <strong>portabilità</strong></li>
            <li><strong>Rettificare</strong> o <strong>cancellare</strong> il proprio profilo (Diritto all'oblio)</li>
            <li><strong>Revocare il consenso</strong> alla visibilità</li>
          </ul>
          <p>
            Per l'esercizio dei diritti, scrivere a: {' '}
            <a href="mailto:deltaimpianti.de@gmail.com" className="text-orange-500 hover:underline">
              deltaimpianti.de@gmail.com
            </a>
          </p>

          <h2 className="text-xl font-semibold text-slate-900">6. Autorità di Controllo</h2>
          <p>
            L'autorità di riferimento per la protezione dei dati è il <strong>PUODO</strong> (Prezes Urzędu Ochrony 
            Danych Osobowych), Polonia.
          </p>

          {/* Footer */}
          <div className="mt-12 pt-8 border-t border-slate-200">
            <p className="text-sm text-slate-500">
              Per qualsiasi domanda relativa alla presente Privacy Policy, contattare: {' '}
              <a href="mailto:deltaimpianti.de@gmail.com" className="text-orange-500 hover:underline">
                deltaimpianti.de@gmail.com
              </a>
            </p>
            <p className="text-sm text-slate-500 mt-2">
              Vedi anche: <Link to="/terms" className="text-orange-500 hover:underline">Termini di Servizio</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
